import {useDispatch} from 'react-redux';
import {readFeedbackDetail} from '../../../modules/admin/feedback';
import Loading from '../../common/Loading';
import FeedbackMessage from './FeedbackMessage';
import {ReactComponent as EmptyIcon} from '../../../assets/feedback/empty.svg';
import {ReactComponent as NoSearchIcon} from '../../../assets/feedback/nosearch.svg';
import {ReactComponent as ErrorIcon} from '../../../assets/feedback/error.svg';
import styles from './styles/table.module.css';

export default function FeedbackTable({ state, s_type, start_date, end_date, employee, content, listResponse = {}, listErrorResponse, listLoading }) {
    const dispatch = useDispatch();

    const validateParams = () => {
        return !!(state || s_type || start_date || end_date || employee || content); // 하나라도 존재하면 true
    };

    const changeState = (state) => {
        if (state === 'NEW') return '대기 중';
        if (state === 'PROGRESS') return '확인 중';
        if (state === 'COMPLETED') return '해결 완료';
    };

    const handleDetail = (id) => {
        dispatch(readFeedbackDetail({ id }));
    };

    return (
        <table className={styles.wrapper}>
            <thead>
            <tr>
                <th></th>
                <th>날짜</th>
                <th>사번</th>
                <th>피드백 내용</th>
            </tr>
            </thead>
            <tbody>
            {listLoading &&
                <tr>
                    <td colSpan={4}>
                        <FeedbackMessage icon={<Loading/>}
                                         message=''
                                         subMessage=''
                        />
                    </td>
                </tr>
            }
            {!listLoading && listResponse && listResponse.content.length > 0 &&
                listResponse.content.map(item => {
                    const { id, state, type, date, employee, content } = item;

                    return (
                        <tr key={id} onClick={() => handleDetail(id)}>
                            <td>
                                <div className={styles.contentType} datatype={state}>{changeState(state)}</div>
                            </td>
                            <td>{date}</td>
                            <td>{employee}</td>
                            <td>
                                <div className={styles.containerContent}>
                                    {content.optionList.map((option, index) => (
                                        <div className={styles.contentOption} key={index}>{option}</div>
                                    ))}
                                    <div className={styles.contentText}>{content.text}</div>
                                </div>
                            </td>
                        </tr>
                    );
                })
            }
            {!listLoading && listResponse && listResponse.content.length === 0 && validateParams() &&
                <tr>
                    <td colSpan={4}>
                        <FeedbackMessage icon={<NoSearchIcon/>}
                                         message='검색된 결과 없음'
                                         subMessage='필터를 삭제하고 다시 시도해 보세요.'
                        />
                    </td>
                </tr>
            }
            {!listLoading && listResponse && listResponse.content.length === 0 && !validateParams() &&
                <tr>
                    <td colSpan={4}>
                        <FeedbackMessage icon={<EmptyIcon/>}
                                         message='등록된 피드백 없음'
                                         subMessage='사용자들의 피드백이 도착할 때까지 기다려 주세요.'
                        />
                    </td>
                </tr>
            }
            {!listLoading && listErrorResponse &&
                <tr>
                    <td colSpan={4}>
                        <FeedbackMessage icon={<ErrorIcon/>}
                                         message={<p style={{ margin: 0, marginBottom: '8px', fontSize: '16px'}}>페이지를 불러오는 중 <span style={{color: 'red' }}>오류</span> 발생</p>}
                                         subMessage='잠시 후 다시 시도해 주세요.'
                        />
                    </td>
                </tr>
            }
            </tbody>
        </table>
    );
}
